import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { SVG_DELETE_DIALOG } from "svg/SVGs";
import AppButton from "components/ui/AppButton";

const DeleteComponent = (props) => {
  const { t } = useTranslation();
  const getTitle = () => {
    const arr = [null, undefined, "", "null", "undefined"];
    if (arr?.includes(props?.title)) return "";
    else return props.title;
  };
  return (
    <Spin spinning={props.loading}>
        <div className="">
          <div className="text-center p-5 flex-auto justify-center">
            <SVG_DELETE_DIALOG />
            <h2 className="text-xl font-extrabold py-4 ">
              {t("Are you sure ?")}
            </h2>
            <p className="px-8">
              <span className="font-bold mx-2">{getTitle()}</span>
              <span>{props?.Heading}</span>
            </p>
          </div>
          <div className="p-3  mt-2 text-center space-x-4 md:block">
            <AppButton variant="secondary" onClick={props.onCancel} size="lg">
              {t("Cancel")}
            </AppButton>
            <AppButton variant="danger" onClick={props.onDelete} size="lg">
              {t("Delete")}
            </AppButton>
          </div>
        </div>
    </Spin>
  );
};
DeleteComponent.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
};
export default DeleteComponent;
